export const rxLpChIsValidPhoneNumber = (phone: string): boolean =>
  /^\+?[\d -]{8,}$/u.test(phone)
